export default function getPuzzleNumberForDate(
	isoDate: string,
	startDate: string,
	daysPerPuzzle = 1
) {
	const start = new Date(startDate).getTime()
	const date = new Date(isoDate).getTime()
	const diff = Math.floor((date - start) / (1000 * 60 * 60 * 24))
	return Math.floor(diff / daysPerPuzzle) + 1
}
